import { Trans } from "@lingui/react/macro";

/**
 * NB: This is not "No records found" since it is also used in places where the user adds items to a list, in which case
 * the word "found" would be misleading.
 */
export const emptyRecordsText = <Trans>No records</Trans>;
